export default {
  clinicFirstStepTitle: 'signup.clinic.firstStep.title',
  clinicFirstStepDesc: 'signup.clinic.firstStep.desc',
  clinicFirstStepInputLabel1: 'signup.clinic.firstStep.inputLabel1',
  clinicFirstStepInputLabel2: 'signup.clinic.firstStep.inputLabel2',
  clinicFirstStepInputLabel3: 'signup.clinic.firstStep.inputLabel3',

  clinicThirdStepTitle: 'signup.clinic.thirdStep.title',
  clinicThirdStepPlanType: 'signup.clinic.thirdStep.planType',
  clinicThirdStepFreeTrial: 'signup.clinic.thirdStep.freeTrial',
  clinicThirdStepButtonText: 'signup.clinic.thirdStep.buttonText',

  clinicFourStepTitle: 'signup.clinic.fourStep.title',
  clinicFourStepDesc: 'signup.clinic.fourStep.desc',

  companyFirstStepTitle: 'signup.company.firstStep.title',
  companyFirstStepDesc: 'signup.company.firstStep.desc',
  companyFirstStepInputLabel1: 'signup.company.firstStep.inputLabel1',
  companyFirstStepInputLabel2: 'signup.company.firstStep.inputLabel2',
  companyFirstStepInputLabel3: 'signup.company.firstStep.inputLabel3',
  companyFirstStepInputLabel4: 'signup.company.firstStep.inputLabel4',
  companyFirstStepInputLabel5: 'signup.company.firstStep.inputLabel5',
  companyFirstStepInputLabel6: 'signup.company.firstStep.inputLabel6',
  companyFirstStepInputLabel7: 'signup.company.firstStep.inputLabel7',
  companyFirstStepbuttonText: 'signup.company.firstStep.buttonText',

  companyThirdStepTitle: 'signup.company.thirdStep.title',
  companyThirdStepDesc: 'signup.company.thirdStep.desc',
  companyThirdStepLooksGood: 'signup.company.thirdStep.looksGood',
  companyFourStepTitle: 'signup.company.fourStep.title',
  companyFourStepDesc: 'signup.company.fourStep.desc',

  secondStepTitle: 'signup.secondStep.title',
  secondStepDesc: 'signup.secondStep.desc',
  secondStepAccountLink: 'signup.secondStep.accountLink',

  secondStepInputLabel1: 'signup.secondStep.inputLabel1',
  secondStepInputLabel2: 'signup.secondStep.inputLabel2',
  secondStepInputLabel3: 'signup.secondStep.inputLabel3',
  secondStepInputLabel4: 'signup.secondStep.inputLabel4',
  secondStepInputLabel5: 'signup.secondStep.inputLabel5',

  menu: {
    plans: 'bottomMenu.plans',
    product: 'bottomMenu.product',
    contact: 'bottomMenu.contact',
    freeTrial: 'bottomMenu.freeTrial',
  },

  infoBlock: {
    yourName: 'signup.infoBlock.yourName',
    yourPosition: 'signup.infoBlock.yourPosition',
    email: 'signup.infoBlock.email',
    phone: 'signup.infoBlock.phone',
    companyName: 'signup.infoBlock.companyName',
    clinicName: 'signup.infoBlock.clinicName',
    numberOf: 'signup.infoBlock.numberOf',
    clinics: 'signup.infoBlock.clinics',
    computers: 'signup.infoBlock.computers',
  },

  general: {
    step: 'general.step',
    of: 'general.of',
    continue: 'general.continue',
  },
};
